/* unplugin-vue-components disabled */import { ElPagination as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/pagination/style/css';
import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  "class": "block report-list journal-list"
};
var _hoisted_2 = {
  "class": "journal-item"
};
var _hoisted_3 = {
  "class": "media"
};
var _hoisted_4 = {
  "class": "media-left"
};
var _hoisted_5 = {
  "class": "img-box"
};
var _hoisted_6 = {
  "class": "img"
};
var _hoisted_7 = ["src", "alt"];
var _hoisted_8 = {
  "class": "media-body"
};
var _hoisted_9 = ["textContent"];
var _hoisted_10 = {
  "class": "journal-info"
};
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = {
  "class": "journal-info"
};
var _hoisted_13 = ["textContent"];
var _hoisted_14 = {
  "class": "journal-more"
};
var _hoisted_15 = ["onClick"];
var _hoisted_16 = {
  "class": "paging"
};
import { getNewsList } from '../../api/home/news';
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup: function setup(__props) {
    var currentPage = ref(1);
    var newParam = ref({
      pageNum: currentPage.value,
      pageSize: 10
    });
    var newsData = ref([{
      name: '',
      context: '',
      pushDate: '',
      image: '',
      id: '',
      intro: '',
      createTime: ''
    }]);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            lists();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var total = ref(0);
    function lists() {
      return _lists.apply(this, arguments);
    }
    function _lists() {
      _lists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res$data$records, _res$data, _res$data$total, _res$data2, _res$data$current, _res$data3;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getNewsList(newParam.value);
            case 2:
              res = _context2.sent;
              console.log(res, 'resss');
              if (res.code == 200) {
                newsData.value = (_res$data$records = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.records) !== null && _res$data$records !== void 0 ? _res$data$records : [];
                total.value = (_res$data$total = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.total) !== null && _res$data$total !== void 0 ? _res$data$total : 0;
                currentPage.value = (_res$data$current = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.current) !== null && _res$data$current !== void 0 ? _res$data$current : 1;
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _lists.apply(this, arguments);
    }
    function handelCurrentChange(pageNum) {
      newParam.value.pageNum = pageNum;
      lists();
    }
    var router = useRouter();
    function clickItem(id) {
      router.push("/broadcastItem/".concat(id));
    }
    return function (_ctx, _cache) {
      var _component_el_pagination = __unplugin_components_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsData), function (item) {
        return _openBlock(), _createElementBlock("div", {
          "class": "container",
          key: item.id
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: item.image,
          alt: item.name
        }, null, 8, _hoisted_7)])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
          "class": "journal-title",
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", {
          innerHTML: item.context
        }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", {
          textContent: _toDisplayString(item.createTime)
        }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", {
          "class": "more-btn btn-small",
          onClick: function onClick($event) {
            return clickItem(item.id);
          }
        }, "查看更多", 8, _hoisted_15)])])])])]);
      }), 128))]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_pagination, {
        "current-page": _unref(currentPage),
        "onUpdate:currentPage": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(currentPage) ? currentPage.value = $event : null;
        }),
        onCurrentChange: handelCurrentChange,
        background: "",
        layout: "prev, pager, next",
        total: _unref(total),
        "class": "mt-4"
      }, null, 8, ["current-page", "total"])])], 64);
    };
  }
});